import React from "react";
import VerifyPasswordResetToken from "../components/VerifyPasswordResetToken";

const VerifyPasswordResetTokenPage = () => {
  return (
    <>

      {/* SignInLayer */}
      <VerifyPasswordResetToken />

    </>
  );
};

export default VerifyPasswordResetTokenPage;   
